import React from 'react';
import { Carousel, Row, Col, Icon } from 'sd-ui-components';
import './CarouselDots.less';

const DOTS_TO_SHOW = 6;
const EXTRA_DOT_BUFFER = 1;

class CarouselDots extends React.Component {
  carouselRef = null;
  state = {
    currentSlice: 0
  };

  constructor(props) {
    super(props);

    this.setState({
      currentSlice: Math.floor(this.props.selectedIndex / DOTS_TO_SHOW)
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedIndex !== prevProps.selectedIndex) {
      const selectedSliceIndex = Math.floor(
        this.props.selectedIndex / DOTS_TO_SHOW
      );
      this.setState({ currentSlice: selectedSliceIndex });
      this.carouselRef && this.carouselRef.goTo(selectedSliceIndex);
    }
  }

  skipForward = () => {
    this.props.onGoToIndex &&
      this.props.onGoToIndex(this.props.selectedIndex + 1);
  };

  skipBackward = () => {
    this.props.onGoToIndex &&
      this.props.onGoToIndex(this.props.selectedIndex - 1);
  };

  afterChange = current => {
    this.setState({ currentSlice: current });
  };

  initCarouselRef = carouselRef => {
    if (!carouselRef) {
      return;
    }
    this.carouselRef = carouselRef;
  };

  render() {
    const { dots } = this.props;
    const count = dots.length;

    let slices = [dots.slice(0, DOTS_TO_SHOW + EXTRA_DOT_BUFFER)];
    let sliceIndex = DOTS_TO_SHOW;

    while (sliceIndex < count) {
      slices.push(
        dots.slice(
          sliceIndex - EXTRA_DOT_BUFFER,
          sliceIndex + DOTS_TO_SHOW + EXTRA_DOT_BUFFER
        )
      );
      sliceIndex += DOTS_TO_SHOW;
    }

    return (
      <div className="slick-dots carousel-dots-overflow-container">
        <Row type="flex" justify="center" align="top" gutter={0}>
          <Col span={2} className="carousel-dots-prev-column  carousel-arrow">
            {this.props.selectedIndex > 0 && (
              <Icon icon="chevron-left" onClick={this.skipBackward} />
            )}
          </Col>

          <Col span={8} className="carousel-dots-column">
            <Carousel
              externalNavigation={false}
              dots={false}
              arrows={false}
              data-automation-id="carousel-dots-overflow-carousel"
              infinite={false}
              centerPadding={0}
              afterChange={this.afterChange}
              ref={this.initCarouselRef}
            >
              {slices.map((slice, index) => (
                <ul key={index}>{slice}</ul>
              ))}
            </Carousel>
          </Col>

          <Col span={2} className="carousel-dots-next-column carousel-arrow">
            {this.props.selectedIndex < this.props.dots.length - 1 && (
              <Icon icon="chevron-right" onClick={this.skipForward} />
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

export default CarouselDots;



// WEBPACK FOOTER //
// ./src/containers/EventDetails/CarouselDots.jsx